const EVENT_PREFIX = 'gift_editor_';

export enum Events {
    CHANGE_VARIANT = 'change_variant',
    APPLY_MAGIC_BORDER = 'apply_magic_border',
    REMOVE_MAGIC_BORDER = 'remove_magic_border',
    APPLY_PATTERN = 'apply_pattern',
    REMOVE_PATTERN = 'remove_pattern',
    ADD_ACCESSORY = 'add_accessory',
    REMOVE_ACCESSORY = 'remove_accessory',
    CHANGE_ACCESSORY = 'change_accessory',
    CREATE_PHOTO_GROUP = 'create_photo_group',
}

export const pushEvent = (event: Events, data: Record<string, unknown>) => {

    if (typeof window === 'undefined' || !window) {
        return;
    }

    // @ts-ignore
    if (!window.dataLayer) window.dataLayer = [];

    // @ts-ignore
    window.dataLayer.push({
        event: `${EVENT_PREFIX}${event}`,
        custom_event: `${EVENT_PREFIX}${event}`,
        customDimensions: JSON.stringify({
            'UserSegment': `gift-editor`
        }),
        details: data ? formatDetails(data) : "{}"
    });

    // Push clear event to prevent data from being sent to other events
    // @ts-ignore
    window.dataLayer.push({event: null, details: null, customDimensions: null});
};

const formatDetails = (details: Record<string, unknown>) => {
    const formattedDetails: Record<string, string> = {};

    for (const [key, value] of Object.entries(details)) {
        formattedDetails[key] = String(value);
    }

    return JSON.stringify(formattedDetails);
};